import StepWrapper from "./StepWrapper";
import { Form, Button, ButtonGroup } from "react-bootstrap";

const EmployeeBaseSalaryStep = ({ data, onSubmit, totalSteps }) => {
  const isSalary =
    typeof data?.salaryDetails?.baseSalary === "number" &&
    !Number.isNaN(data.salaryDetails.baseSalary);

  const handlePaymentTypeChange = (type) => {
    onSubmit({
      ...(data || {}),
      salaryDetails: {
        ...(data?.salaryDetails || {}),
        baseSalary:
          type === "salary" ? data?.salaryDetails?.baseSalary ?? 0 : null,
      },
    });
  };

  return (
    <StepWrapper
      step={data.step}
      total={totalSteps}
      onPrev={() => onSubmit({ step: data.step - 1 })}
      onNext={() => onSubmit({ step: data.step + 1 })}
    >
      <Form.Group className="mb-3">
        <Form.Label>Select Payment Type</Form.Label>
        <ButtonGroup className="d-flex">
          <Button
            variant={isSalary ? "secondary" : "primary"}
            onClick={() => handlePaymentTypeChange("advance")}
          >
            Advance
          </Button>
          <Button
            variant={isSalary ? "primary" : "secondary"}
            onClick={() => handlePaymentTypeChange("salary")}
          >
            Salary
          </Button>
        </ButtonGroup>
      </Form.Group>

      <Form.Group>
        <Form.Label className={isSalary ? "" : "text-muted"}>
          Total Employee Salary
        </Form.Label>
        <Form.Control
          type="number"
          min={0}
          required={isSalary}
          disabled={!isSalary}
          // placeholder="Enter Total Salary Amount of Employee"
          value={(data?.salaryDetails?.baseSalary ?? "")?.toString()}
          onChange={(e) =>
            onSubmit({
              ...(data || {}),
              salaryDetails: {
                ...(data?.salaryDetails || {}),
                baseSalary: Number(e.target.value),
              },
            })
          }
          autoFocus
        />
      </Form.Group>
    </StepWrapper>
  );
};

const toNumber = (x) => {
  const n = Number(x);
  console.log(x, n, Number(x));
  return n;
};

export default EmployeeBaseSalaryStep;
